import {pack} from './pack'
import {unpack} from './unpack'
import type {CorePlugin, SingleComponentPlugin} from '../../types'
import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'

export const classicLayoutSingleComponentPlugin = {
    name: 'ClassicLayoutPlugin',
    pack,
    unpack
} satisfies SingleComponentPlugin

export const classicLayoutPlugin: CorePlugin = createPluginFromSingleComponentPlugin(classicLayoutSingleComponentPlugin)
